'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherCircle, FeatherLoader } from '@subframe/core';
import { Loader } from '@/shared/components/ui';
import type { FormatoDownload, StatusDoPacote } from '../../types/baixarProcesso.types';
import { passosDaGeracao, rotuloDoStatus, type SituacaoPasso } from '../../utils/passosGeracao';
const ICONE_DO_PASSO: Record<SituacaoPasso, React.ReactNode> = {
  concluido: <FeatherCheck className="text-success-600 h-[15px] w-[15px]" />,
  emAndamento: <FeatherLoader className="text-brand-600 h-[15px] w-[15px] animate-spin" />,
  aguardando: <FeatherCircle className="h-[15px] w-[15px] text-neutral-300" />
};
const TEXTO_DO_PASSO: Record<SituacaoPasso, string> = {
  concluido: 'text-neutral-500',
  emAndamento: 'text-default-font font-medium',
  aguardando: 'text-neutral-400'
};

/** O ícone e o tom não bastam: o estado de cada passo também vai em texto para o leitor de tela. */
const ESTADO_DO_PASSO: Record<SituacaoPasso, string> = {
  concluido: 'concluído',
  emAndamento: 'em andamento',
  aguardando: 'aguardando'
};
interface EtapaGerandoProps {
  formato: FormatoDownload;
  /** `null` enquanto o pedido não teve resposta. */
  status: StatusDoPacote | null;
}

/**
 * Sem porcentagem: o servidor não informa progresso, e a barra de antes andava sozinha por um
 * relógio. O indicador é indeterminado e os passos seguem o status real do pacote.
 */
export function EtapaGerando(t0) {
  const $ = _c(19);
  const {
    formato,
    status
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== formato || $[1] !== status) {
    const passos = passosDaGeracao(formato, status);
    t3 = "flex w-full flex-col gap-5 px-6 pt-1 pb-[26px]";
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Loader size="small" />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== status) {
      t6 = rotuloDoStatus(status);
      $[7] = status;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    if ($[9] !== t6) {
      t4 = <div className="flex items-center gap-2.5 text-[13px] text-neutral-600">{t5}<span className="text-default-font font-medium">{t6}</span></div>;
      $[9] = t6;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t1 = "m-0 flex list-none flex-col gap-3 rounded-[12px] bg-neutral-50 px-[18px] py-4";
    t2 = passos.map(_temp);
    $[0] = formato;
    $[1] = status;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2) {
    t5 = <ol className={t1}>{t2}</ol>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-[12.5px] leading-[1.6] text-neutral-500">Você pode fechar esta janela. Se a geração passar de um minuto, terminamos em segundo plano e avisamos por e-mail.</p>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp(passo) {
  return <li className={`flex items-center gap-2.5 text-[13px] ${TEXTO_DO_PASSO[passo.situacao]}`} key={passo.titulo}><span aria-hidden="true" className="flex-none">{ICONE_DO_PASSO[passo.situacao]}</span>{passo.titulo}<span className="sr-only">: {ESTADO_DO_PASSO[passo.situacao]}</span></li>;
}